export enum FrameworkModes {
    Create,
    Edit
}